import { Accordion, Flex, useMantineTheme } from "@mantine/core";
import { ArrowDown2, TextalignLeft } from "iconsax-react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { navbarLinks } from "../../constants/links";
import { client_selected } from "../../client";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconPrediX } from "../../assets/Icons/IconPrediX.svg";

type IProps = {
  close: () => void;
};

const AccordionMenu = ({ close }: IProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useMantineTheme();
  const [value, setValue] = useState<string | null>(null);
  const { roleSelected } = useAuth();
  const redirectClient = client_selected.redirect;
  const { t } = useTranslation();
  const isGenial = client_selected.name === "Genial";

  return (
    <Accordion
      value={value}
      onChange={setValue}
      variant="filled"
      bg={theme.colors.primary[0]}
      styles={{
        chevron: {
          svg: {
            height: "24px",
            width: "24px",
          },
        },
        item: {
          border: "none",
          borderRadius: "unset",
          background: "unset",
          fontWeight: 600,
          fontFamily: "Barlow",
          lineHeight: "25px",
          color: theme.colors.basic[0],
          marginTop: "8px",
          ":nth-of-type(1)": {
            marginTop: "unset",
          },
          "&[data-active]": {
            background: "rgba(255, 255, 255, 0.05)",
          },
        },
        control: {
          color: theme.colors.basic[0],
          padding: "16px 24px",
          transition: "all 0.5s ease",
          ":hover": {
            background: "rgba(255, 255, 255, 0.05)",
          },
        },
        label: {
          fontWeight: 600,
          fontFamily: "Barlow",
          lineHeight: "25px",
        },
        content: {
          fontWeight: 600,
          fontFamily: "Barlow",
          lineHeight: "25px",
          padding: "unset",
        },
      }}
    >
      {navbarLinks(roleSelected).map((navLink, index) => {
        return (
          <Accordion.Item
            key={`${navLink.name}${index}`}
            value={navLink.path}
            onClick={() => {
              if (!!!navLink.subLinks) {
                if (navLink.path?.startsWith("http")) {
                  window.open(navLink.path, "_blank", "noopener,noreferrer");
                } else {
                  navigate(navLink.path);
                }
                close();
              }
            }}
          >
            <>
              <Accordion.Control
                chevron={
                  <ArrowDown2
                    size="24p"
                    style={{ opacity: !!navLink.subLinks ? 1 : 0 }}
                  />
                }
                sx={{
                  backgroundColor:
                    !navLink.subLinks && location.pathname === navLink.path
                      ? theme.colors.basic[0]
                      : "unset",
                  color:
                    !navLink.subLinks && location.pathname === navLink.path
                      ? theme.colors.primary[0]
                      : theme.colors.basic[0],
                  ":hover": {
                    backgroundColor:
                      location.pathname === navLink.path
                        ? theme.colors.basic[0]
                        : "rgba(255, 255, 255, 0.05)",
                    opacity: location.pathname === navLink.path ? 0.9 : "unset",
                  },
                }}
              >
                {t(navLink.name)}
              </Accordion.Control>
              {!!navLink.subLinks ? (
                <Accordion.Panel>
                  {navLink.subLinks.map((item, index) => {
                    const labelTranslated = t(item.name);

                    const labelWithIcon =
                      isGenial && labelTranslated === "PrediX" ? (
                        <>
                          {
                            <IconPrediX
                              width={20}
                              height={20}
                              style={{
                                marginRight: 5,
                              }}
                              stroke={theme.colors.primary[0]}
                            />
                          }
                          {labelTranslated}
                        </>
                      ) : (
                        labelTranslated
                      );
                    return (
                      <Flex key={`${item}${index}`} direction="column">
                        <Link
                          to={!!item?.path ? item?.path : redirectClient}
                          style={{
                            textDecoration: "unset",
                          }}
                          onClick={() => {
                            close();
                          }}
                        >
                          <Flex
                            p="16px 24px 16px 48px"
                            sx={{
                              borderTop: "2px solid",
                              borderColor: theme.colors.primary[0],
                              backgroundColor:
                                location.pathname === item.path
                                  ? theme.colors.basic[0]
                                  : "unset",
                              color:
                                location.pathname === item.path
                                  ? theme.colors.primary[0]
                                  : theme.colors.basic[0],
                              transition: "all 0.5s ease",
                              ":hover": {
                                backgroundColor:
                                  location.pathname === item.path
                                    ? theme.colors.basic[0]
                                    : "rgba(255, 255, 255, 0.05)",
                                opacity:
                                  location.pathname === item.path
                                    ? 0.9
                                    : "unset",
                              },
                            }}
                          >
                            {labelWithIcon}
                          </Flex>
                        </Link>
                      </Flex>
                    );
                  })}
                </Accordion.Panel>
              ) : null}
            </>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

export default AccordionMenu;
